import { Questionnaire } from '@app/questionnaire/types/Questionnaire';
import { Application } from '../types/Application';

export const getName = (data: Partial<Application | Questionnaire>) => {
  return `${data?.firstName || ''} ${data?.lastName || ''}`.trim();
};
